import { Toast as BaseUIToast } from '@base-ui/react/toast';

import { ToastViewport } from '../ToastViewport/ToastViewport';
import type { ToastProviderProps } from './ToastProvider.types';

// Base UI makes toasts beyond its limit inert and unclosable; without a queue every toast has to stay operable.
const TOAST_LIMIT = Number.POSITIVE_INFINITY;

export const ToastProvider = ({ children }: ToastProviderProps) => (
  <BaseUIToast.Provider timeout={3000} limit={TOAST_LIMIT}>
    {children}
    <ToastViewport />
  </BaseUIToast.Provider>
);
